export const jobs = [
  {
    id: "senior-insulation-technician-grand-rapids",
    title: "Senior Insulation Technician / Field Leader",
    department: "Field Leadership",
    location: "Grand Rapids, MI 49503",
    type: "Full-time",
    salary: "Competitive Based on Experience",
    postedDate: "October 24, 2024",
    travel: "Local / Regional",
    description: "Are you an experienced insulation professional ready to lead? We are looking for a Field Leader who excels at technical execution and team coordination. If you have a track record of quality and leadership, we want to talk to you.",
    overview: "As a Senior Technician and Field Leader at MAG Insulation, you will not only perform high-quality installations but also mentor junior technicians and ensure project standards are met on-site. This role is ideal for a professional looking for a long-term career path with leadership responsibilities.",
    responsibilities: [
      "Lead and coordinate on-site installation teams.",
      "Execute complex insulation installs (Fiberglass, Cellulose, Spray Foam).",
      "Interpret project blueprints and manage material requirements.",
      "Conduct quality control checks upon project completion.",
      "Mentor and train junior insulation technicians.",
      "Maintain strict adherence to safety protocols and company standards."
    ],
    qualifications: [
      "3+ years of professional insulation or construction experience.",
      "Proven leadership or supervisory experience in a field setting.",
      "Expert knowledge of insulation materials and application techniques.",
      "Strong communication skills and ability to lead a team.",
      "Valid driver's license and clean driving record.",
      "Must pass background check and DOT 10-panel drug screen."
    ],
    benefits: [
      "Choice of three medical plan options through Blue Cross Blue Shield and Blue Care Network",
      "Comprehensive dental, vision, and flexible spending account (FSA) options",
      "Company-paid basic life insurance",
      "Company-paid short-term and long-term disability insurance",
      "401(k) with company matching",
      "Leadership performance bonuses",
      "Paid Time Off and Holiday pay",
      "Company vehicle access for job sites"
    ],
    questions: [
      "Do you have at least 2 years of experience leading a field crew in construction or insulation?"
    ]
  },
  {
    id: "insulation-technician-grand-rapids",
    title: "Insulation Technician",
    department: "Installation",
    location: "Grand Rapids, MI 49503",
    type: "Full-time",
    salary: "From $18 upward",
    postedDate: "October 24, 2024",
    travel: "Local",
    description: "Join our Grand Rapids crew! We are looking for motivated individuals ready to learn the insulation trade and grow with a leading company. No experience? We provide full on-the-job training.",
    overview: "As an Insulation Technician, you are the backbone of our service. You'll work hands-on to improve energy efficiency for our customers. We value reliability, a positive attitude, and a willingness to work hard.",
    responsibilities: [
      "Install fiberglass, cellulose, and other insulation materials.",
      "Prepare job sites and ensure clean completion of projects.",
      "Assist senior technicians with complex equipment setup.",
      "Follow all safety guidelines and wear required PPE.",
      "Maintain company tools and equipment in good working order."
    ],
    qualifications: [
      "Reliable, punctual, and ready to work in a physical environment.",
      "Ability to work in various conditions (attics, crawl spaces, etc.).",
      "Team-oriented mindset with good problem-solving skills.",
      "Valid driver's license and reliable transportation.",
      "Must pass background check and DOT 10-panel drug screen."
    ],
    benefits: [
      "Choice of three medical plan options through Blue Cross Blue Shield and Blue Care Network",
      "Comprehensive dental, vision, and flexible spending account (FSA) options",
      "Company-paid basic life insurance",
      "Company-paid short-term and long-term disability insurance",
      "On-the-job training program",
      "Weekly pay schedule",
      "401(k) matching after 1 year",
      "All tools and safety gear provided"
    ],
    questions: [
      "Are you comfortable working in confined spaces like attics or crawl spaces?"
    ]
  },
  {
    id: "insulation-technician-traverse-city",
    title: "Insulation Technician",
    department: "Installation",
    location: "Traverse City, MI 49686",
    type: "Full-time",
    salary: "From $18 upward",
    postedDate: "October 24, 2024",
    travel: "Local",
    description: "MAG Insulation is expanding in Traverse City! We need energetic individuals to join our professional installation crew. Build a career with a company that values your hard work.",
    overview: "This role serves the northern Michigan region, providing critical energy-saving solutions to homeowners and builders. We offer a stable, year-round work environment with great benefits.",
    responsibilities: [
      "Perform residential and commercial insulation installs.",
      "Work with specialized blowing machines and spray equipment.",
      "Ensure all installs meet MAG Insulation's high quality standards.",
      "Interact professionally with customers on-site.",
      "Accurately document material usage for each project."
    ],
    qualifications: [
      "Motivated to learn a skilled trade.",
      "Physical stamina for climbing ladders and handling materials.",
      "Strong work ethic and attention to detail.",
      "Valid driver's license is required.",
      "Must pass background check and DOT 10-panel drug screen."
    ],
    benefits: [
      "Choice of three medical plan options through Blue Cross Blue Shield and Blue Care Network",
      "Comprehensive dental, vision, and flexible spending account (FSA) options",
      "Company-paid basic life insurance",
      "Company-paid short-term and long-term disability insurance",
      "Competitive hourly wages + overtime",
      "Paid training and certifications",
      "Uniforms and safety equipment provided",
      "Stable, year-round employment"
    ],
    questions: [
      "Do you have a valid driver's license and reliable transportation to our Traverse City office?"
    ]
  }
];